module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[18]17.c2d9789.woff2";